import { AppState } from './app.state';

// selectors
export const selectUserProfile = (state: AppState) => state.userProfile;
export const selectLoadingStatus = (state: AppState) => state.loadingStatus;
export const selectLoadingError = (state: AppState) => state.loadingError;




// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/angular-router-loader/src!./~/tslint-loader!./src/app/app.selector.ts